import React from 'react'
import { IMemberBenefit } from '@verzekeringapp-mono/shared/src/models/member_benefit'

interface IProps {
  memberBenefit: IMemberBenefit
}

const MemberBenefitContent: React.FC<IProps> = ({ memberBenefit }) => {
  const openExternalLink = () => {
    if (memberBenefit?.link) {
      window.open(memberBenefit.link, '_blank', 'noreferrer')
    }
  }

  return (
    <div>
      {memberBenefit?.link && (
        <button
          className='mb-4 flex w-full items-center justify-center rounded-lg border border-border-default bg-surface-card'
          onClick={openExternalLink}
        >
          <p className='py-4'>Ga naar de actiepagina</p>
        </button>
      )}

      {memberBenefit?.content && (
        <div
          className='html-content p-4 rounded'
          dangerouslySetInnerHTML={{ __html: memberBenefit?.content }}
        />
      )}
    </div>
  )
}

export default MemberBenefitContent
